import { RootLayout } from "@/aptim/aptim";
// import img from "~/img/undraw_login_re_4vu2.svg?url";
import { appDetails } from "~/utils/misc";

export default function Layout({ children, title, subtitle, img }) {
  return (
    <RootLayout>
      <div className="flex min-h-screen">
        <div className="flex flex-1 flex-col justify-center px-4 py-6 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96 bg-white">
            <div className="flex flex-col items-center">
              <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-foreground text-center">
                {title}
              </h2>
              <h3>{subtitle}</h3>
            </div>
            <div className="mt-10">{children}</div>
          </div>
        </div>
        <div className="relative hidden w-0 flex-1 lg:block">
          <img
            className="absolute inset-0 h-full w-full object-scale-down"
            src={img}
            alt={appDetails.title}
          />
        </div>
      </div>
    </RootLayout>
  );
}
